import { ContextualCommentsPanelContent } from '@makemydeal/dr-shared-components';
import { ContextualCommentsContainer } from './DealComments.style';
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { useSelector } from 'react-redux';
import { useClickOutside } from '../common/useClickOutside';
import { useRef } from 'react';
import type { RefObject } from 'react';
import { HostEnvironment, hostUrlHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

type DealCommentsProps = {
    isOpen?: boolean;
    onClose?: () => void;
    styleVariant: 'deal-comments-drawer' | 'deal-comments-baseFooter' | 'deal-comments-footer';
    commentsElementRef?: RefObject<HTMLElement>;
};

const DealComments = ({ isOpen, onClose, styleVariant, commentsElementRef }: DealCommentsProps) => {
    const dealExchangeDealId = useSelector(offerReduxSelectors.getDealXgId);
    const commonOrgId = useSelector(offerReduxSelectors.getCommonOrgId);
    const environment = hostUrlHelper.getHostUrlEnvironment(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref());
    const isProd = (env: HostEnvironment) => env === HostEnvironment.Prod || env === HostEnvironment.DarkProd;
    const partition = isProd(environment) ? 'prod' : 'non-prod';
    const baseUrl = useSelector(configSelectors.getLaunchUrl);
    const mentionsDivRef = useRef<HTMLDivElement>(null);

    // The drawer variant has no button/onClose — its parent controls visibility by whether it mounts
    // this component at all, so it always renders open once mounted.
    const visible = !onClose || !!isOpen;

    const noop = () => undefined;
    // Inert for the drawer variant (no onClose — its parent owns visibility, click-outside is
    // meaningless there) and only live while the panel is actually visible, not on every click
    // for the component's whole mounted lifetime.
    useClickOutside(mentionsDivRef, onClose ?? noop, { ignoreClick: () => !onClose || !visible });

    return (
        <ContextualCommentsContainer data-testid={styleVariant} className={styleVariant} $visible={visible} ref={mentionsDivRef}>
            <ContextualCommentsPanelContent
                referenceId={dealExchangeDealId}
                commonOrgId={commonOrgId}
                launchUrl={baseUrl}
                partition={partition}
                isOpen={visible}
                onClose={onClose}
                commentsElementRef={commentsElementRef}
            />
        </ContextualCommentsContainer>
    );
};
export default DealComments;
